import { useCallback, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { buscarEu, listarPedidos, podeFazer } from './acesso';
import type { Eu } from './acesso';
import { sair, sessaoAtual } from './auth';
import type { Sessao } from './auth';
import { NaoEncontrada } from './design/Estados';
import { SpriteDeIcones } from './design/Icone';
import PainelDaFundacao from './PainelDaFundacao';
import { Shell } from './shell/Shell';
import { ShellBalconista } from './shell/ShellBalconista';
import type { RotaDoBalconista } from './shell/ShellBalconista';
import { VisaoGeralDeVendas } from './telas/central/VisaoGeral';
import { LucroDoInovapayTela } from './telas/loja/LucroDoInovapay';
import { VidaDoProdutoTela } from './telas/loja/VidaDoProduto';
import { QuadroDeHorarioTela } from './telas/equipe/QuadroDeHorario';
import { DetalheDoBlocoDoGiro, OperacaoDeHoje, VisaoGeralDoGiro } from './telas/giro/Operacao';
import { GeracaoDoGiro, SetoresEBlocos } from './telas/giro/Geracao';
import { ConfiguracaoDoGiro } from './telas/giro/Configuracao';
import { OcorrenciasDoGiro } from './telas/giro/Ocorrencias';
import { BloqueadosDoGiro } from './telas/giro/BloqueadosDoGiro';
import { RelatorioDoGiro } from './telas/giro/RelatorioDoGiro';
import { CapacidadeEBloqueios } from './telas/giro/CapacidadeEBloqueios';
import { PainelDoGiro } from './telas/giro/PainelDoGiro';
import { RupturasDoGiro } from './telas/giro/Rupturas';
import { GiroDoBalconista } from './telas/giro/GiroDoBalconista';
import { lerMeuGiro } from './giro';
import {
  EquipeEPresenca,
  ExcecoesDaGeracao,
  HistoricoDeOperacoes,
  RodizioDoGiro,
} from './telas/giro/Equipe';
import { CupomDoHos, MovimentacaoDeVendas } from './telas/central/Movimentacao';
import { ExcecoesComerciais } from './telas/central/Excecoes';
import { DevolucoesECancelamentos } from './telas/central/Devolucoes';
import { PagamentosDoCaixa } from './telas/central/Pagamentos';
import { PrecosEMargem } from './telas/central/Precos';
import { GiroMaxTela } from './telas/giro/GiroMax';
import { TelaDesempenho } from './telas/balconista/Desempenho';
import { Inicio } from './telas/balconista/Inicio';
import { MinhasVendas } from './telas/balconista/MinhasVendas';
import { Pagando } from './telas/balconista/Pagando';
import { ComoFunciona } from './telas/balconista/ComoFunciona';
import { RegistrarVenda } from './telas/balconista/RegistrarVenda';
import { MinhaConta } from './telas/conta/MinhaConta';
import { Redirecionar } from './telas/Redirecionar';
import { Aprovacoes } from './telas/equipe/Aprovacoes';
import { Encomendas } from './telas/encomendas/Encomendas';
import type { AreaDeEncomendas } from './telas/encomendas/Encomendas';
import { Equipe } from './telas/equipe/Equipe';
import { Perfis } from './telas/equipe/Perfis';
import { Login } from './telas/login/Login';
import { Paradao } from './telas/paradao/Paradao';
import { PreVencidos } from './telas/prevencidos/PreVencidos';
import { Conferencia } from './telas/premiacao/Conferencia';
import { MinhaPremiacao } from './telas/premiacao/MinhaPremiacao';
import { Premiacao } from './telas/premiacao/Premiacao';
import { Ranking } from './telas/premiacao/Ranking';
import { TudoPorBalconista } from './telas/premiacao/TudoPorBalconista';
import { PerfilComercial } from './telas/vendas/Perfil';
import { Vendas } from './telas/vendas/Vendas';
import { Produtos } from './telas/produtos/Produtos';
import { CasoDeDivergencia } from './telas/auditoria/CasoDeDivergencia';
import { CentralDeDivergencias } from './telas/auditoria/CentralDeDivergencias';
import { AnaliseDoCaso } from './telas/divergencias/AnaliseDoCaso';
import { CentralPremium } from './telas/divergencias/CentralPremium';
import { ConferenciaRapida } from './telas/divergencias/ConferenciaRapida';
import { PainelDivergencias } from './telas/divergencias/PainelDivergencias';
import { QualidadeDaEquipe } from './telas/divergencias/QualidadeDaEquipe';
import { MinhasAuditorias } from './telas/auditoria/MinhasAuditorias';
import { QualidadeDoGiro } from './telas/auditoria/QualidadeDoGiro';
import { Dashboard } from './telas/paineis/Dashboard';
import { Graficos } from './telas/paineis/Graficos';
import { Home } from './telas/paineis/Home';
import { PainelInovaPay } from './telas/inovapay/PainelInovaPay';
import {
  ConferenciaDoPrograma,
  PROGRAMAS,
  ProdutosDoPrograma,
  RankingDoPrograma,
  SubnavDoPrograma,
  VisaoDoPrograma,
  abaDaRota,
  rotaDaAba,
} from './telas/inovapay/Programa';
import { Insights } from './telas/paineis/Insights';
import { ModoTV } from './telas/paineis/ModoTV';
import { Configuracoes } from './telas/administracao/Configuracoes';
import { ProtecaoDeTela } from './design/ProtecaoDeTela';
import { ValoresOcultos, VeCusto } from './design/sigilo';
import { Integracoes } from './telas/administracao/Integracoes';
import { MeuMural } from './telas/administracao/MeuMural';
import { Mural } from './telas/administracao/Mural';
import { RegrasECampanhas } from './telas/administracao/RegrasECampanhas';
import { MetasEPremiacao } from './telas/metas/MetasEPremiacao';
import { CrieSuaSenha } from './telas/conta/CrieSuaSenha';
import { SaudeEAuditoria } from './telas/administracao/SaudeEAuditoria';
import { ControladosDoDia } from './telas/controlados/ControladosDoDia';
import { ConferirGeladeira } from './telas/geladeira/ConferirGeladeira';
import { PainelGeladeira } from './telas/geladeira/PainelGeladeira';

/**
 * A RAIZ DO INOVAPAY 2.0.
 *
 * Decide uma coisa só: há sessão ou não. A sessão é do SERVIDOR (cookie HttpOnly); a tela só
 * pergunta. Falha de rede ao perguntar NÃO vira "deslogado" — vira o estado de verificação, e a
 * pessoa não é jogada no login só porque o wi-fi oscilou.
 *
 * Logado, pergunta QUEM é (`/api/me`, Bloco 2): nome e perfil para o shell, capacidades para
 * esconder o que não é da pessoa. Se o servidor disser que a sessão acabou (suspensão, senha
 * trocada em outro aparelho), volta para o login.
 *
 * `#/sistema` mantém o painel técnico da fundação (P0): saúde da API e do banco.
 */

type Estado =
  | { readonly fase: 'verificando' }
  | { readonly fase: 'sem-sessao' }
  | { readonly fase: 'logado'; readonly sessao: Sessao };

function rotaAtual(): string {
  return window.location.hash.replace(/^#\/?/, '');
}

/** "aprovacoes?pedido=abc" → ["aprovacoes", {pedido: "abc"}]. */
function separar(rota: string): [string, URLSearchParams] {
  const [base = '', consulta = ''] = rota.split('?');
  return [base, new URLSearchParams(consulta)];
}

const AREAS_DE_ENCOMENDAS: readonly AreaDeEncomendas[] = [
  'encomendas',
  'encomendas-minhas',
  'encomendas-todas',
  'encomendas-revisar',
  'encomendas-recebimento',
  'encomendas-faltas',
  'encomendas-config',
  'encomendas-auditoria',
];

export default function App() {
  const [estado, setEstado] = useState<Estado>({ fase: 'verificando' });
  const [rotaCompleta, setRota] = useState(rotaAtual);
  const [eu, setEu] = useState<Eu | null>(null);
  const [pendentes, setPendentes] = useState<number | null>(null);
  // `/api/me` falhou sem ser por sessão (rede): segue com o shell padrão em vez de travar.
  const [euFalhou, setEuFalhou] = useState(false);
  const [giroBloqueia, setGiroBloqueia] = useState(false);
  const [rota, parametros] = separar(rotaCompleta);
  const moduloDoPrograma = abaDaRota(rota);

  useEffect(() => {
    const aoMudar = () => setRota(rotaAtual());
    window.addEventListener('hashchange', aoMudar);
    return () => window.removeEventListener('hashchange', aoMudar);
  }, []);

  useEffect(() => {
    let vivo = true;
    void sessaoAtual().then((s) => {
      if (!vivo) return;
      // `undefined` = não deu para perguntar. Trata como sem sessão SÓ para abrir o login; o
      // login, ao tentar entrar, é que vai mostrar "sem conexão" se for o caso.
      setEstado(s ? { fase: 'logado', sessao: s } : { fase: 'sem-sessao' });
    });
    return () => {
      vivo = false;
    };
  }, []);

  const logado = estado.fase === 'logado';
  useEffect(() => {
    if (!logado) {
      setEu(null);
      setPendentes(null);
      return;
    }
    let vivo = true;
    void buscarEu().then(async (r) => {
      if (!vivo) return;
      if (!r.ok) {
        if (r.falha.tipo === 'sem-sessao') setEstado({ fase: 'sem-sessao' });
        else setEuFalhou(true);
        return;
      }
      setEu(r.dados);
      if (podeFazer(r.dados, 'equipe.aprovar')) {
        const p = await listarPedidos('pendente');
        if (vivo && p.ok) setPendentes(p.dados.pedidos.length);
      }
    });
    return () => {
      vivo = false;
    };
  }, [logado]);

  const aoMudarPendentes = useCallback((n: number) => setPendentes(n), []);
  // Trocou a foto em "Minha conta": o avatar do shell muda na hora.
  const aoMudarFoto = useCallback(
    (foto: string | null) => setEu((atual) => (atual ? { ...atual, foto } : atual)),
    [],
  );

  // O balconista tem o shell dele (tela 06): registra venda e não vê as vendas de todos.
  const balconista =
    eu !== null && podeFazer(eu, 'vendas.registrar') && !podeFazer(eu, 'vendas.ver_todas');
  // O auditor usa o shell do administrador com o menu dele (tela 22).
  const auditor =
    eu !== null && podeFazer(eu, 'giro.auditar') && !podeFazer(eu, 'giro.administrar');

  // O receptor (0058) só recebe a mercadoria: entra direto no Recebimento.
  const receptor =
    eu !== null &&
    podeFazer(eu, 'encomendas.receber') &&
    !podeFazer(eu, 'encomendas.ver_todas') &&
    !podeFazer(eu, 'vendas.registrar') &&
    // o auditor que também recebe (Iggor) continua abrindo na fila da auditoria
    !podeFazer(eu, 'giro.auditar');
  const areaDeEncomendas = AREAS_DE_ENCOMENDAS.includes(rota as AreaDeEncomendas)
    ? (rota as AreaDeEncomendas)
    : null;

  // Gate do Giro (tela 19): o SERVIDOR diz se há Giro obrigatório pendente. Com a regra ligada,
  // qualquer rota do InovaPay cai no Giro até a conclusão — recarregar ou digitar a URL não libera.
  const podeGiro = eu !== null && podeFazer(eu, 'giro.executar');
  useEffect(() => {
    if (!balconista || !podeGiro) return;
    let vivo = true;
    void lerMeuGiro().then((r) => vivo && r.ok && setGiroBloqueia(r.dados.bloqueiaInovapay));
    return () => {
      vivo = false;
    };
  }, [balconista, podeGiro, rotaCompleta]);
  const giroFocado =
    estado.fase === 'logado' &&
    balconista &&
    podeGiro &&
    (rota === 'giro' || (giroBloqueia && !['conta', 'preferencias'].includes(rota)));

  if (rota === 'sistema') {
    return <PainelDaFundacao />;
  }
  // Modo TV (tela 12 C): painel de parede, sem sidebar — só para quem vê o painel completo. Quem
  // não vê recebe o aviso do próprio Modo TV ("este acesso não abre o painel"), nunca outra tela.
  if (rota === 'tv' && estado.fase === 'logado' && eu !== null) {
    return (
      <>
        <SpriteDeIcones />
        <ModoTV parametros={parametros} permitido={podeFazer(eu, 'painel.ver_completo')} />
      </>
    );
  }

  const sairAgora = () => {
    if (estado.fase !== 'logado') return;
    void sair(estado.sessao).then(() => {
      window.location.hash = '';
      setEstado({ fase: 'sem-sessao' });
    });
  };

  // SENHA PROVISÓRIA (dono, 29/09): antes de qualquer tela, criar a senha definitiva.
  if (estado.fase === 'logado' && eu?.acessoProvisorio)
    return (
      <>
        <SpriteDeIcones />
        <CrieSuaSenha sessao={estado.sessao} nome={eu.nomeExibicao} aoSair={sairAgora} />
      </>
    );

  let pagina: ReactNode = null;
  let rotaDoBalconista: RotaDoBalconista = 'inicio';
  let tituloDoBalconista: string | null = null;
  if (estado.fase === 'logado' && balconista) {
    const s = estado.sessao;
    // Entrar no InovaPay abre o MEU DESEMPENHO (dono, 28/09); o Início continua no menu.
    if (rota === 'inicio') pagina = <Inicio eu={eu} />;
    else if (
      rota === '' ||
      rota === 'visao-geral' ||
      rota === 'desempenho' ||
      rota === 'painel' ||
      rota === 'ranking'
    ) {
      rotaDoBalconista = 'desempenho';
      tituloDoBalconista = 'Meu desempenho';
      pagina = <TelaDesempenho eu={eu} sessao={s} />;
    } else if (rota === 'vendas') {
      rotaDoBalconista = 'vendas';
      tituloDoBalconista = 'Registrar venda';
      pagina = <RegistrarVenda key={rotaCompleta} eu={eu} sessao={s} parametros={parametros} />;
    } else if (rota === 'como-funciona') {
      rotaDoBalconista = 'desempenho';
      tituloDoBalconista = 'Como funciona a premiação';
      pagina = <ComoFunciona />;
    } else if (rota === 'pagando') {
      rotaDoBalconista = 'pagando';
      tituloDoBalconista = 'O que está pagando';
      pagina = <Pagando />;
    } else if (rota === 'minhas') {
      rotaDoBalconista = 'minhas';
      tituloDoBalconista = 'Minhas vendas';
      pagina = <MinhasVendas eu={eu} sessao={s} />;
    } else if (rota === 'premiacao') {
      rotaDoBalconista = 'minhas';
      tituloDoBalconista = 'Minha premiação';
      pagina = <MinhaPremiacao eu={eu} />;
    } else if (rota === 'giro') {
      rotaDoBalconista = 'giro';
      tituloDoBalconista = 'Giro de Prateleira';
      pagina = null;
    } else if (areaDeEncomendas) {
      rotaDoBalconista = 'encomendas';
      tituloDoBalconista = 'Encomendas';
      pagina = <Encomendas eu={eu} sessao={s} area={areaDeEncomendas} />;
    } else if (rota === 'conta' || rota === 'preferencias') {
      rotaDoBalconista = 'conta';
      tituloDoBalconista = 'Minha conta';
      pagina = (
        <MinhaConta
          eu={eu}
          sessao={s}
          foco={rota === 'preferencias' ? 'preferencias' : 'dados'}
          aoSair={sairAgora}
          aoMudarFoto={aoMudarFoto}
        />
      );
    } else if (rota === 'escala' || rota === 'quadro-de-horario') {
      // Quadro de horário (dono 24/10): a equipe vê o quadro, a própria escala e faz pedidos.
      tituloDoBalconista = 'Quadro de horário';
      pagina = (
        <QuadroDeHorarioTela
          key={parametros.get('aba') ?? ''}
          sessao={s}
          parametros={parametros}
          rota="escala"
        />
      );
    } else if (rota === 'controlados' && podeFazer(eu, 'controlados.conferir')) {
      // Armário (dono 26/10): a farmacêutica confere os controlados vendidos no dia anterior.
      tituloDoBalconista = 'Controlados do dia';
      pagina = <ControladosDoDia key={parametros.toString()} sessao={s} parametros={parametros} />;
    } else if (rota === 'pre-vencidos') {
      tituloDoBalconista = 'Pré-vencidos';
      pagina = <PreVencidos sessao={s} eu={eu} />;
    } else if (rota === 'paradao') {
      tituloDoBalconista = 'Paradão';
      pagina = <Paradao sessao={s} eu={eu} />;
    } else if (rota === 'produtos') {
      tituloDoBalconista = 'Produtos';
      pagina = <Produtos sessao={s} eu={eu} />;
    } else if (rota === 'vitaminas') {
      tituloDoBalconista = 'Vitaminas';
      pagina = <Produtos key="vitaminas" sessao={s} eu={eu} filtroInicial="vitaminas" />;
    } else if (rota === 'mural') {
      tituloDoBalconista = 'Avisos';
      pagina = <MeuMural sessao={s} eu={eu} />;
    } else if (rota === 'minhas-auditorias') {
      rotaDoBalconista = 'desempenho';
      tituloDoBalconista = 'Minhas auditorias';
      pagina = <MinhasAuditorias eu={eu} />;
    } else if (rota === 'caso' && !parametros.get('id')) {
      pagina = <Redirecionar para="#/minhas-auditorias" />;
    } else if (rota === 'caso' && parametros.get('id')) {
      rotaDoBalconista = 'desempenho';
      tituloDoBalconista = 'Caso';
      pagina = (
        <CasoDeDivergencia
          key={parametros.get('id')}
          sessao={s}
          eu={eu}
          id={parametros.get('id') ?? ''}
        />
      );
    } else {
      tituloDoBalconista = 'Página não encontrada';
      pagina = <NaoEncontrada aoBuscar={() => (window.location.hash = '#/vendas?buscar=1')} />;
    }
  } else if (estado.fase === 'logado') {
    const s = estado.sessao;
    if (receptor && (rota === '' || rota === 'visao-geral'))
      pagina = <Redirecionar para="#/encomendas-recebimento" />;
    else if (areaDeEncomendas) pagina = <Encomendas eu={eu} sessao={s} area={areaDeEncomendas} />;
    else if (rota === 'equipe') pagina = <Equipe sessao={s} eu={eu} />;
    else if (rota === 'aprovacoes')
      pagina = (
        <Aprovacoes
          sessao={s}
          pedidoInicial={parametros.get('pedido')}
          aoMudarPendentes={aoMudarPendentes}
        />
      );
    else if (rota === 'perfis') pagina = <Perfis />;
    else if (rota === 'produtos')
      pagina = (
        <Produtos
          key={`produtos${parametros.toString()}`}
          sessao={s}
          eu={eu}
          parametros={parametros}
        />
      );
    // Os módulos dos programas (InovaPay): Visão geral · Produtos · Lançamentos · Conferência · Ranking
    else if (moduloDoPrograma) {
      const { chave, aba } = moduloDoPrograma;
      if (aba === 'visao')
        pagina = <VisaoDoPrograma key={chave} chave={chave} parametros={parametros} />;
      else if (aba === 'conferencia')
        pagina = <ConferenciaDoPrograma key={chave} chave={chave} parametros={parametros} />;
      else if (aba === 'ranking')
        pagina = <RankingDoPrograma key={chave} chave={chave} parametros={parametros} />;
      else if (aba === 'lancamentos')
        pagina = (
          <Vendas
            key={chave}
            sessao={s}
            eu={eu}
            parametros={parametros}
            programaFixo={PROGRAMAS[chave].programa}
            rota={rotaDaAba(chave, 'lancamentos')}
            cabeca={<SubnavDoPrograma chave={chave} atual="lancamentos" />}
          />
        );
      else
        pagina = (
          <ProdutosDoPrograma chave={chave} aba={aba} parametros={parametros}>
            {(periodo) =>
              chave === 'vitaminas' ? (
                <Produtos
                  key="vitaminas"
                  sessao={s}
                  eu={eu}
                  filtroInicial="vitaminas"
                  lancados={periodo.lancados}
                />
              ) : chave === 'pre-vencidos' ? (
                <PreVencidos
                  key={aba}
                  sessao={s}
                  eu={eu}
                  abaFixa={
                    aba === 'vencimentos' || aba === 'vencidos' || aba === 'alertas'
                      ? aba
                      : 'catalogo'
                  }
                  lancados={periodo.lancados}
                  validade={periodo.validade}
                />
              ) : (
                <Paradao sessao={s} eu={eu} lancados={periodo.lancados} />
              )
            }
          </ProdutosDoPrograma>
        );
    } else if (rota === 'premiacao')
      pagina = <Premiacao key={parametros.toString()} sessao={s} eu={eu} parametros={parametros} />;
    else if (rota === 'conferencia')
      pagina = (
        <Conferencia key={parametros.toString()} sessao={s} eu={eu} parametros={parametros} />
      );
    else if (rota === 'ranking') pagina = <Ranking eu={eu} balconista={false} />;
    else if (rota === 'tudo-por-balconista')
      pagina = <TudoPorBalconista key={parametros.toString()} parametros={parametros} />;
    else if (rota === 'vendas') pagina = <VisaoGeralDeVendas parametros={parametros} />;
    else if (rota === 'lucro-inovapay') pagina = <LucroDoInovapayTela parametros={parametros} />;
    else if (rota === 'vida-do-produto') pagina = <VidaDoProdutoTela parametros={parametros} />;
    else if (rota === 'quadro-de-horario')
      pagina = (
        <QuadroDeHorarioTela key={parametros.get('aba') ?? ''} sessao={s} parametros={parametros} />
      );
    else if (rota === 'lancamentos') pagina = <Vendas sessao={s} eu={eu} parametros={parametros} />;
    else if (rota === 'movimentacao') pagina = <MovimentacaoDeVendas parametros={parametros} />;
    else if (rota === 'cupom' && parametros.get('id'))
      pagina = <CupomDoHos id={parametros.get('id') ?? ''} destaque={parametros.get('destaque')} />;
    else if (rota === 'cupom') pagina = <Redirecionar para="#/movimentacao" />;
    else if (rota === 'excecoes')
      pagina = <ExcecoesComerciais sessao={s} parametros={parametros} />;
    else if (rota === 'precos')
      pagina = (
        <PrecosEMargem
          veCusto={eu !== null && podeFazer(eu, 'produtos.configurar')}
          parametros={parametros}
          sessao={s}
        />
      );
    else if (rota === 'pagamentos') pagina = <PagamentosDoCaixa parametros={parametros} />;
    else if (rota === 'devolucoes') pagina = <DevolucoesECancelamentos parametros={parametros} />;
    else if (rota === 'giro') pagina = <VisaoGeralDoGiro />;
    else if (rota === 'giro-operacao')
      pagina = <OperacaoDeHoje sessao={s} parametros={parametros} />;
    else if (rota === 'giro-bloco' && parametros.get('g'))
      pagina = (
        <DetalheDoBlocoDoGiro
          geracaoId={parametros.get('g') ?? ''}
          numero={Number(parametros.get('n') ?? 1)}
        />
      );
    else if (rota === 'giro-bloco') pagina = <Redirecionar para="#/giro-operacao" />;
    else if (rota === 'giro-geracao') pagina = <GeracaoDoGiro sessao={s} />;
    else if (rota === 'giro-setores') pagina = <SetoresEBlocos sessao={s} />;
    else if (rota === 'giro-config') pagina = <ConfiguracaoDoGiro sessao={s} />;
    else if (rota === 'giro-equipe')
      pagina = <EquipeEPresenca sessao={s} parametros={parametros} />;
    else if (rota === 'giro-rodizio') pagina = <RodizioDoGiro />;
    else if (rota === 'giro-excecoes') pagina = <ExcecoesDaGeracao />;
    else if (rota === 'giro-ocorrencias') pagina = <OcorrenciasDoGiro sessao={s} />;
    else if (rota === 'giro-capacidades') pagina = <CapacidadeEBloqueios sessao={s} />;
    else if (rota === 'giro-bloqueados') pagina = <BloqueadosDoGiro sessao={s} />;
    else if (rota === 'giro-relatorio') pagina = <RelatorioDoGiro />;
    else if (rota === 'giro-painel') pagina = <PainelDoGiro />;
    else if (rota === 'giro-rupturas') pagina = <RupturasDoGiro />;
    else if (rota === 'giro-historico') pagina = <HistoricoDeOperacoes />;
    else if (rota === 'giro-max') pagina = <GiroMaxTela />;
    // Bloco 11 — auditoria (telas 22, 23 e 24). O auditor começa pela fila.
    // Divergências 3.0 premium (dono, 13/10): central nova, conferência rápida e investigação.
    // A recontagem do fluxo antigo segue na central clássica.
    else if (rota === 'recontagens')
      pagina = (
        <CentralDeDivergencias sessao={s} eu={eu} parametros={parametros} aba="recontagens" />
      );
    else if (
      rota === 'divergencias' ||
      rota === 'concluidas' ||
      rota === 'historico-auditoria' ||
      ((rota === '' || rota === 'visao-geral') && auditor)
    ) {
      const p = new URLSearchParams(parametros);
      if (rota === 'concluidas') p.set('aba', 'concluidas');
      if (rota === 'historico-auditoria') p.set('aba', 'historico');
      // Endereço novo (link, voltar) = tela nova com aqueles filtros; mexer nos filtros não remonta.
      pagina = <CentralPremium key={p.toString()} sessao={s} eu={eu} parametros={p} />;
    } else if (rota === 'conferir')
      pagina = (
        <ConferenciaRapida
          key={parametros.get('local') ?? ''}
          sessao={s}
          eu={eu}
          parametros={parametros}
        />
      );
    else if (rota === 'geladeira-conferir') pagina = <ConferirGeladeira sessao={s} />;
    else if (rota === 'controlados')
      pagina = <ControladosDoDia key={parametros.toString()} sessao={s} parametros={parametros} />;
    else if (rota === 'geladeira')
      pagina = (
        <PainelGeladeira
          sessao={s}
          parametros={parametros}
          podeAdministrar={eu !== null && podeFazer(eu, 'geladeira.administrar')}
        />
      );
    else if (rota === 'divergencias-painel') pagina = <PainelDivergencias sessao={s} eu={eu} />;
    else if (rota === 'qualidade-equipe') pagina = <QualidadeDaEquipe sessao={s} eu={eu} />;
    else if (rota === 'caso' && parametros.get('id'))
      pagina =
        parametros.get('classica') !== '1' &&
        (podeFazer(eu, 'divergencia.decidir') ||
          podeFazer(eu, 'auditoria.ver_todos') ||
          podeFazer(eu, 'giro.auditar')) ? (
          <AnaliseDoCaso
            key={parametros.get('id')}
            sessao={s}
            eu={eu}
            id={parametros.get('id') ?? ''}
          />
        ) : (
          <CasoDeDivergencia
            key={parametros.get('id')}
            sessao={s}
            eu={eu}
            id={parametros.get('id') ?? ''}
          />
        );
    else if (rota === 'caso') pagina = <Redirecionar para="#/divergencias" />;
    // "Minhas auditorias" no shell do administrador: quem vê todos os casos volta para a fila;
    // os demais veem os próprios casos, como no shell do balconista.
    else if (rota === 'minhas-auditorias')
      pagina =
        eu !== null &&
        (podeFazer(eu, 'auditoria.ver_todos') ||
          podeFazer(eu, 'giro.auditar') ||
          podeFazer(eu, 'auditoria.analisar')) ? (
          <Redirecionar para="#/divergencias" />
        ) : (
          <MinhasAuditorias eu={eu} />
        );
    else if (rota === 'qualidade')
      pagina = <QualidadeDoGiro sessao={s} eu={eu} parametros={parametros} />;
    // Bloco 12 — painéis (telas 05, 11 e 12). Relatórios abre os Gráficos; Desempenho, o Dashboard.
    // A Visão geral é da LOJA (só o dono). Para quem administra o InovaPay sem ser dono, a primeira
    // tela é o Painel do InovaPay — nenhum número da loja.
    else if (
      (rota === '' || rota === 'visao-geral') &&
      !auditor &&
      eu !== null &&
      podeFazer(eu, 'loja.ver')
    )
      pagina = <Home eu={eu} parametros={parametros} />;
    else if (
      rota === 'inovapay' ||
      ((rota === '' || rota === 'visao-geral') && !auditor && eu !== null)
    )
      pagina = <PainelInovaPay eu={eu} parametros={parametros} />;
    else if (rota === 'dashboard' || rota === 'desempenho')
      pagina = <Dashboard eu={eu} parametros={parametros} />;
    else if (rota === 'graficos' || rota === 'relatorios')
      pagina = <Graficos eu={eu} parametros={parametros} />;
    else if (rota === 'insights') pagina = <Insights eu={eu} parametros={parametros} />;
    // Bloco 13 — administração (telas 29, 30, 34, 35 e 36).
    else if (rota === 'regras' || rota === 'campanhas')
      pagina = (
        <RegrasECampanhas
          sessao={s}
          eu={eu}
          parametros={parametros}
          aba={rota === 'campanhas' ? 'campanhas' : 'regras'}
        />
      );
    else if (rota === 'metas') pagina = <MetasEPremiacao sessao={s} eu={eu} />;
    else if (rota === 'comunicacao') pagina = <Mural sessao={s} eu={eu} parametros={parametros} />;
    else if (rota === 'mural') pagina = <MeuMural sessao={s} eu={eu} />;
    else if (rota === 'configuracoes')
      pagina = <Configuracoes sessao={s} eu={eu} parametros={parametros} />;
    else if (rota === 'integracoes') pagina = <Integracoes eu={eu} />;
    else if (rota === 'auditoria') pagina = <SaudeEAuditoria eu={eu} parametros={parametros} />;
    else if (rota === 'perfil' && parametros.get('pessoa'))
      pagina = <PerfilComercial accountId={parametros.get('pessoa') ?? ''} />;
    else if (rota === 'perfil') pagina = <Redirecionar para="#/equipe" />;
    else if (rota === 'conta' || rota === 'preferencias')
      pagina = (
        <MinhaConta
          eu={eu}
          sessao={s}
          foco={rota === 'preferencias' ? 'preferencias' : 'dados'}
          aoSair={sairAgora}
          aoMudarFoto={aoMudarFoto}
        />
      );
    else
      pagina = (
        <NaoEncontrada
          aoBuscar={() =>
            window.dispatchEvent(new KeyboardEvent('keydown', { key: 'k', ctrlKey: true }))
          }
        />
      );
  }

  return (
    <ValoresOcultos.Provider value={eu?.valoresOcultos === true}>
      <SpriteDeIcones />
      {estado.fase === 'verificando' && <div className="app-verificando" aria-busy="true" />}
      {estado.fase === 'sem-sessao' && (
        <Login aoEntrar={(sessao) => setEstado({ fase: 'logado', sessao })} />
      )}
      {/* Antes de saber quem é, nenhum dos dois shells: não pisca o do admin para o balconista. */}
      {estado.fase === 'logado' && eu === null && !euFalhou && (
        <div className="app-verificando" aria-busy="true" />
      )}
      {giroFocado && estado.fase === 'logado' && (
        <GiroDoBalconista sessao={estado.sessao} eu={eu} aoSair={sairAgora} />
      )}
      {estado.fase === 'logado' && eu !== null && balconista && !giroFocado && (
        <ShellBalconista rota={rotaDoBalconista} eu={eu} titulo={tituloDoBalconista}>
          <VeCusto.Provider value={eu !== null && podeFazer(eu, 'loja.ver')}>
            <ProtecaoDeTela chave={rotaCompleta}>{pagina}</ProtecaoDeTela>
          </VeCusto.Provider>
        </ShellBalconista>
      )}
      {estado.fase === 'logado' && (eu !== null || euFalhou) && !balconista && (
        <Shell rota={rota} eu={eu} pendentes={pendentes} aoSair={sairAgora}>
          <VeCusto.Provider value={eu !== null && podeFazer(eu, 'loja.ver')}>
            <ProtecaoDeTela chave={rotaCompleta}>{pagina}</ProtecaoDeTela>
          </VeCusto.Provider>
        </Shell>
      )}
    </ValoresOcultos.Provider>
  );
}
